import { Box, Text, ThemeContext } from '@vouched.id/vault';
import React, { useContext } from 'react';
import { Tooltip } from './Tooltip';
import { useTableStyles } from './utils';
export const SingleSpanTable = ({ caption, numColumns, items, header }) => {
    const { tokens } = useContext(ThemeContext).theme;
    const { captionStyles, tableStyles, thStyles, tdStyles } = useTableStyles();
    return (React.createElement(Box, { marginY: "spacing.xlarge" },
        React.createElement("table", { style: tableStyles },
            caption && React.createElement("caption", { style: captionStyles }, caption),
            React.createElement("tbody", null,
                header ? (React.createElement("tr", null,
                    React.createElement("th", { colSpan: numColumns, style: { ...thStyles, textAlign: 'center' } }, header))) : (React.createElement("tr", null,
                    React.createElement("th", { style: thStyles }, "Field"),
                    React.createElement("th", { style: thStyles }, "Value"),
                    numColumns === 3 && React.createElement("th", { style: thStyles }, "Result"))),
                items.map((item) => (React.createElement("tr", { key: item.label },
                    React.createElement("td", { style: tdStyles },
                        React.createElement(Box, { alignItems: "center", display: "flex", justifyContent: "flex-start", style: { gap: '5px' } },
                            React.createElement(Text, { style: {
                                    ...(item.value === undefined && {
                                        color: tokens.colors.textInverseMuted
                                    })
                                } }, item.label),
                            item.labelTooltip && (React.createElement(Box, null,
                                React.createElement(Tooltip, null, item.labelTooltip))))),
                    React.createElement("td", { style: tdStyles },
                        React.createElement(Text, { "data-ph-mask": true, style: { ...(item.valueColor && { color: item.valueColor }) } }, item.value)),
                    numColumns === 3 && React.createElement("td", { style: tdStyles }, item.statusIcon))))))));
};
